import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerBOLM implements IOwner {
    constructor(owner: OwnerBOLM) {
        Object.assign(this, owner);
    }
    id: number;
    containerOwnerId: number;
    ownerLookUpId: number;
    ownerType: string;
    regionalOffice: string;
    address: Address;
    phoneNumberChanges?: PhoneNumberChanges;
    contactPersonDetailsId: number;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    email: string;
    stateId: number;
    note: string;
    isPrimaryDeviation: boolean;
    isClientAcreage: boolean;
    ssnTaxId: string;

    ownerName() {
        return this.regionalOffice;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerBOLM.ts